import axios from 'axios';
import {welfareAPIUrl} from "Constants/defaultValues";
// Define the maximum number of retries for network errors
const MAX_RETRIES = 3

const instance = axios.create({
    baseURL: welfareAPIUrl
})

// Annotate the error message with the failing endpoint so downstream
// loggers (which typically call err.toString()) record which URL failed.
const annotateErrorWithUrl = (error) => {
    const config = error?.config;
    if (!config || error?.__urlAnnotated) return;
    const method = config.method ? config.method.toUpperCase() : "REQUEST";
    const url = `${config.baseURL || ""}${config.url || ""}`;
    if (!url) return;
    const status = error?.response?.status;
    const statusPart = status ? ` [${status}]` : "";
    error.message = `${error.message}${statusPart} | ${method} ${url}`;
    error.__urlAnnotated = true;
};

instance.interceptors.response.use(undefined, async error => {
    // Check if the error is a "Network Error"
    if (!error.response && error.message === "Network Error") {
        const config = error.config;

        // If config does not exist or the retry option was not set, reject
        if (!config || !instance.defaults.retry) return Promise.reject(error);

        // Set the variable for keeping track of the retry count
        config.__retryCount = config.__retryCount || 0;

        // Check if we've maxed out the total number of retries
        if (config.__retryCount >= MAX_RETRIES) {
            return Promise.reject(error);
        }

        // Increase the retry count
        config.__retryCount += 1;

        // Create a new promise to handle exponential backoff
        const backoff = new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, (config.__retryCount) * 1000);  // Here, we use a delay of 1 second for each retry attempt. Adjust as needed.
        });

        // Wait for the backoff to complete, then retry the request.
        await backoff;
        return instance(config);
    }

    annotateErrorWithUrl(error);
    return Promise.reject(error);
});

instance.defaults.retry = true;

export default instance;